import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchWeddingData } from 'apollo/projects.query';
import * as types from './types';

function* getSingleProject(action) {
  const { payload } = action || {};
  try {
    const response = yield call(fetchWeddingData, payload);
    yield put({ type: types.GET_SINGLE_PROJECT_SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: types.GET_SINGLE_PROJECT_FAIL });
  }
}

export default function* watchList() {
  yield takeLatest(types.GET_SINGLE_PROJECT, getSingleProject);
}
